import ChangePasswordView from './ChangePasswordView';
export default ChangePasswordView;
